@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.icon {
  width: 16px;
  height: 16px;
  padding: 7px;
  color: var(--grey-600);
}
